import './EmailNotVerified.component.scss';

import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch } from 'react-redux';

import { ERoutes } from '../../../assets/constants/routes';
import { ENotification } from '../../../domain/notification.interface';
import { verifyEmail } from '../../../store/current-user/current-user.actions';
import history from '../../../store/history/history';
import { returnNotification } from '../../../store/render-controller/render-controller.actions';
import { TopBannerComponent } from '../../atoms/atoms.index';
import { NavbarComponent } from '../../organisms/organisms.index';

export function EmailNotVerifiedComponent(props: any) {

  const dispatch = useDispatch();
  const userId = props.match.params.userId;
  console.log(userId);

  async function submitRequest() {
    if (!userId) {
      return;
    }
    const res = await verifyEmail(userId);
    let notification;
    if (!!res && res.status === 201) {
      notification = {
        type: ENotification.SUCCESS,
        msg1: 'success.resend-mail',
        cb: {
          func: history.push,
          param: ERoutes.HOME,
        },
      };
      dispatch(returnNotification(notification));
    } else {
      notification = {
        type: ENotification.ERROR,
        msg1: 'error.ResendEmailException',
      };
      dispatch(returnNotification(notification));
    }
  }

  return (
    <React.Fragment>
      <div className='page-container login-page'>
        <NavbarComponent
          showName={false}
          showLogout={false}
          showHelp={true}
          hideBack={true}
          noNavigateHome={true}
        />
        <TopBannerComponent />
        <div className='content-wrapper'>
          <section className='login-form-container pb-5'>
            <div className='d-flex flex-column'>
              <div className='login-content'>
                <h4 className='subtitle'>
                  <FormattedMessage id='pages.login.verification_mail_page_title' />
                </h4>
                <p className='text-primary-lg font-weight-light'>
                  <FormattedMessage id='pages.login.verification_mail_page_subtitle' />
                </p>
                <button className='btn-lili btn-login' onClick={() => submitRequest()}>
                  <FormattedMessage id='pages.login.verification_mail_page_button_label' />
                </button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </React.Fragment>
  );
}
